export const UI_URL = Object.freeze({
  HOME: "/",
});
